export default class BinaryFilter {
  constructor(getter, operator, value) {
    this.getter = getter;
    this.operator = operator;
    this.value = value;
  }

  negated() {
    return new BinaryFilter(this.getter, this.negatedOperator, this.value);
  }

  get escapedValue() {
    if (typeof this.value !== 'string') return this.value;

    return this.value.replace(/[%_\\]/g, c => `\\${c}`);
  }

  get negatedOperator() {
    switch (this.operator) {
      case '=':
        return '<>';
      case '<>':
        return '=';
      case '>':
        return '<=';
      case '>=':
        return '<';
      case '<':
        return '>=';
      case '<=':
        return '>';
      case 'startswith':
        return 'notstartswith';
      case 'notstartswith':
        return 'startswith';
      case 'endswith':
        return 'notendswith';
      case 'notendswith':
        return 'endswith';
      case 'contains':
        return 'notcontains';
      case 'notcontains':
        return 'contains';
      default:
        throw Error(`cannot negate ${this.operator}`);
    }
  }

  get predicate() {
    switch (this.operator) {
      case '=':
        return { eq: this.value };
      case '<>':
        return { neq: this.value };
      case '>':
        return { gt: this.value };
      case '>=':
        return { gte: this.value };
      case '<':
        return { lt: this.value };
      case '<=':
        return { lte: this.value };
      case 'startswith':
        return { like: `${this.escapedValue}%` };
      case 'notstartswith':
        return { nlike: `${this.escapedValue}%` };
      case 'endswith':
        return { like: `%${this.escapedValue}` };
      case 'notendswith':
        return { nlike: `%${this.escapedValue}` };
      case 'contains':
        return { like: `%${this.escapedValue}%` };
      case 'notcontains':
        return { nlike: `%${this.escapedValue}%` };
      default:
        throw Error(`unexpected operator ${this.operator}`);
    }
  }

  toWhere() {
    return { [this.getter]: this.predicate };
  }
}
